<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <el-row :gutters="15">
      <el-col :sm="12">
        <h4 class="form-title">Inventory Report</h4>
      </el-col>
      <el-col :sm="12">
        <div class="text-right">
          <!--  <el-select
            v-model="pager.supplier_id"
            placeholder="Select supplier here"
            @change="fetch"
            clearable
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            ></el-option>
          </el-select> -->
          <el-button type="primary" size="small" @click="dialogView = true">
            Filter <span class="el-icon-search"></span>
          </el-button>
          <el-button
            class="ml-1"
            v-show="list.data.length > 0"
            type="primary"
            size="small"
            @click="download"
            >Download Report</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-dialog ref="dialog" :visible.sync="dialogView" title="Report Filter">
      <el-form label-position="left" label-width="120px">
        <el-form-item label="Supplier">
          <el-select
            v-model="pager.supplier_id"
            placeholder="Select supplier here"
            filterable
            clearable
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Item Type">
          <el-select
            v-model="pager.item_type"
            placeholder="Select item type"
            clearable
            filterable
          >
            <el-option :value="1" label="Purchased"></el-option>
            <el-option :value="2" label="Salvaged"></el-option>
            <el-option :value="3" label="Consignment"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="Part">
          <el-select
            v-model="pager.part_id"
            placeholder="Select part information here"
            clearable
            filterable
          >
            <el-option
              v-for="item in parts"
              :key="item.id"
              :label="item.part_no"
              :value="item.part_no"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-button type="primary" @click="fetch(1)">Search</el-button>
      </el-form>
    </el-dialog>
    <el-table :data="list.data">
      <!-- <el-table-column type="index"></el-table-column> -->
      <el-table-column label="Part No." prop="part_no"></el-table-column>
      <el-table-column label="Description" prop="description"></el-table-column>
      <el-table-column label="Supplier" prop="supplier"></el-table-column>
      <!-- <el-table-column
        label="Stock Batch"
        prop="stocks.batch_no_id"
      ></el-table-column> -->
      <el-table-column label="Stock Batch" prop="batch_no"></el-table-column>
      <el-table-column label="Final Price (AED)" prop="stocks.final_price_aed">
        <template slot-scope="scope">
          <span>{{ scope.row.final_price_aed | currency("AED ") }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="Final Price (USD)" prop="stocks.final_price_usd">
        <template slot-scope="scope">
          <span>{{ scope.row.final_price_usd | currency("$ ") }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        label="Remaining Quantity"
        prop="stocks.remaining_quantity"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.remaining_quantity | number("0,0") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Item Type" prop="item_type"></el-table-column>
      <el-table-column
        label="Is Non-Moving"
        prop="non_moving"
      ></el-table-column>
    </el-table>
    <el-row
      :gutters="15"
      type="flex"
      align="middle"
      v-show="list.data.length > 0"
    >
      <el-col :sm="12">
        <el-pagination
          v-show="!isLoading"
          class="pt-1 pb-1"
          background
          layout="prev, pager, next"
          :total="list.paging.total"
          :page-size="pager.limit"
          :current-page="parseInt(list.paging.cur_page)"
          @current-change="fetch"
        ></el-pagination>
      </el-col>
      <el-col :sm="12" class="text-right">
        <!-- <a v-show="pager.supplier_id" :href="baseUrl"></a> -->
        <el-button type="primary" size="small" @click="download"
          >Download Report</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";
// import Part from "@/models/Part";
export default {
  name: "InventoryReport",
  computed: {
    suppliers() {
      return this.$store.getters["supplier/glossary"];
    },
    report_url() {
      let url = `/api/v1/inventory/download_inventory/?`;
      if (this.pager.supplier_id) {
        url += `&supplier_id=${this.pager.supplier_id}`;
      }
      if (this.pager.item_type) {
        url += `&item_type=${this.pager.item_type}`;
      }

      return url;
    }
  },
  data() {
    return {
      isLoading: false,
      list: { data: [], paging: {} },
      parts: [],
      pager: {
        page: 1,
        limit: 25,
        search: "",
        supplier_id: "",
        item_type: ""
      },
      dialogView: false
    };
  },
  methods: {
    fetch(page) {
      // if (!this.pager.supplier_id) return;
      this.isLoading = true;
      // this.pager.page = page;
      // console.log(this.pager);
      let params = {
        page: page ? page : this.pager.page,
        limit: this.pager.limit,
        supplier_id: this.pager.supplier_id,
        item_type: this.pager.item_type
      };
      this.dialogView = false;
      api.get(`/api/v1/inventory/report/`, params).then(resp => {
        this.list = resp.data;
        this.isLoading = false;
      });
    },
    download() {
      let supplier = this.suppliers.find(o => {
        return o.id == this.pager.supplier_id;
      });

      let d = moment().format("MM-DD-YYYY");
      let reportInfo = {
        name: `Inventory Report ${d}`,
        ext: ".csv"
      };
      if (supplier) {
        reportInfo.name = `${supplier.name} Inventory Report ${d}`;
      }

      this.isLoading = true;
      api.download(this.report_url, reportInfo).then(() => {
        this.isLoading = false;
      });
    }
  },
  mounted() {
    this.isLoading = true;
    this.$store.dispatch("supplier/getGlossary").then(() => {
      this.isLoading = false;
    });
    // this.fetch(1);
  }
};
</script>

<style lang="css" scoped></style>
